module.exports = __webpack_public_path__ + "img/greenLocation.10a328be.png";